import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import _ from 'lodash';
let intercomOpts = null;
const INTERCOM_APP_ID = 'e163go4q';
const genericAdminGuid = '59481331-ee53-42be-a548-bd87be6ddd4a';
export function isBlocked() {
    return fetch('https://widget.intercom.io', { mode: 'no-cors' })
        .then(() => false)
        .catch(() => true);
}
export function isIntercomAllowed() {
    return (!envFlags.getValue(FLAGS.e2eTest.name) &&
        !intercomOpts.isEmbeddedUseCase &&
        !intercomOpts.isPrintPage &&
        !intercomOpts.isEmbedded);
}
export function hideIntercomOnCurrentPage() {
    if (typeof window.Intercom === 'function') {
        window.Intercom('update', {
            hide_default_launcher: true,
        });
        window.Intercom('hide');
    }
    if (intercomOpts) {
        intercomOpts.isManuallyHidden = true;
    }
}
export function showIntercomOnCurrentPage() {
    if (typeof window.Intercom === 'function') {
        window.Intercom('update', {
            hide_default_launcher: false,
        });
    }
    if (intercomOpts) {
        intercomOpts.isManuallyHidden = false;
    }
}
export function initializeIntercomForUser(logout = false, opts, intercomSettings) {
    intercomOpts = opts;
    if (isIntercomAllowed() && intercomOpts.isIntercomEnabled) {
        setTimeout(() => {
            const obj = { ...intercomSettings };
            if (_.isEmpty(intercomOpts.getUserEmail)) {
                delete obj.email;
            }
            if (_.isEmpty(intercomOpts.getUserGuid)) {
                delete obj.user_id;
            }
            if (obj.user_id === genericAdminGuid && intercomOpts.getClusterId) {
                obj.user_id = `${obj.user_id}-${intercomOpts.getClusterId}`;
            }
            if (logout) {
                window.Intercom('shutdown');
            }
            window.Intercom('boot', obj);
        }, 3000);
    }
}
export async function insertIntercomScript(opts) {
    const internetConnectionBlocked = await isBlocked();
    if (internetConnectionBlocked) {
        return;
    }
    const w = window;
    const ic = w.Intercom;
    const obj = {
        app_id: opts.getIntercomAppId || INTERCOM_APP_ID,
        billing_customer_id: opts.billingCustomerId,
        can_manage_data: opts.canManageData,
        cluster_id: opts.getClusterId,
        cluster_name: opts.getClusterName,
        cluster_url: opts.clusterUrl,
        cluster_version: opts.clusterVersion,
        email: opts.getUserEmail,
        hide_default_launcher: opts.hideLauncher || opts.isManuallyHidden,
        is_admin: opts.hasAdminPrivileges,
        is_developer: opts.hasDeveloperPrivileges,
        name: opts.getUserDisplayName,
        user_role: opts.hasAdminPrivileges ? 'ADMINISTRATOR' : (opts.hasDeveloperPrivileges ? 'DEVELOPER' : 'USER'),
        org_id: opts.orgId,
        purchase_option: opts.purchaseOption,
        release_version: opts.releaseVersion,
        subscription_tier: opts.subscriptionTier,
        subscription_type: opts.subscriptionType,
        team_id: opts.teamId,
        tse_enabled: opts.isEverywhereEnabled,
        user_hash: opts.userHash,
        user_id: opts.getUserGuid,
    };
    if (typeof ic === 'function') {
        w.intercomSettings = obj;
        ic('reattach_activator');
        ic('update', w.intercomSettings);
    }
    else {
        const d = document;
        const i = () => {
            i.c(arguments);
        };
        i.q = [];
        i.c = args => {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = () => {
            setTimeout(() => {
                const s = d.createElement('script');
                s.type = 'text/javascript';
                s.defer = true;
                s.src = `https://widget.intercom.io/widget/${opts.getIntercomAppId ||
                    INTERCOM_APP_ID}`;
                s.onload = () => {
                    initializeIntercomForUser(false, opts, obj);
                };
                const x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            }, 5000);
        };
        if (document.readyState === 'complete') {
            l();
        }
        else {
            w.addEventListener('load', l, false);
        }
    }
}
export async function closeIntercom(logout = true) {
    setTimeout(() => {
        if (logout) {
            window.Intercom?.('shutdown');
        }
    }, 1000);
}
export function fireIntercomEvent(eventName, metadata, isIntercomEnabled) {
    if (isIntercomEnabled && typeof window.Intercom === 'function') {
        window.Intercom('trackEvent', eventName, metadata);
    }
}
//# sourceMappingURL=intercom.js.map